import type {RouteRecordRaw} from "vue-router";
import {EPermissao} from "@/core/type/permissao.type";

/*
 * A tela consome o endpoint próprio fluxo-caixa/consultar (FluxoCaixaService) — mas ainda não existe
 * uma entrada dedicada de Fluxo de Caixa no catálogo EPermissao, então reutiliza a mesma permissão
 * que guarda o item de menu "Fluxo de Caixa" no AppMenu.vue. Não inventar código de permissão
 * (PATTERNS.md) — se o usuário quiser uma permissão própria, é decisão dele.
 */
export const fluxoCaixaRoutes: RouteRecordRaw[] = [
    {
        path: "/fluxo-caixa",
        name: "fluxo-caixa",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_FLUXO_CAIXA},
        component: () => import("@/modules/fluxoCaixa/pages/PageFluxoCaixa.vue")
    },
];
